import { useEffect, useState } from "react";
import { Search, Users, Plus, Settings, LogOut } from "lucide-react";
import { Input } from "src/components/ui/input";
import { Button } from "src/components/ui/button";
import { Badge } from "src/components/ui/badge";
import { Avatar } from "antd";
import { UrlImage } from "../../../lib/api";
import { cn } from "../../../lib/utils";
import { Skeleton } from "src/components/ui/skeleton";

export default function ChatSidebar({
  onSelectUser,
  selectedUser,
  conversation,
  loadingConversation,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const filteredUsers = conversation.filter((u) =>
    u.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    if (!selectedUser && conversation.length > 0) {
      onSelectUser(conversation[0]);
    }
  }, [conversation, selectedUser, onSelectUser]);

  return (
    <aside className="w-16 md:w-64 h-[calc(100vh-6rem)] flex flex-col border-r overflow-y-auto sticky top-0">
      {/* Header */}
      <div className="flex items-center justify-between p-4 ps-0">
        <div className="flex items-center space-x-2">
          <Users className="h-5 w-5" />
          <h2 className="hidden md:block text-lg font-semibold">Contacts</h2>
        </div>
        {/* <button className="p-2 rounded-full hover:bg-gray-100">
          <Plus className="h-5 w-5" />
        </button> */}
      </div>

      {/* Search */}
      <div className="hidden md:block ps-px pe-4 pb-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input
            type="text"
            placeholder="Search users..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-3 py-2 border rounded-lg focus:outline-none focus:ring-2"
          />
        </div>
      </div>

      {/* Recent Chats */}
      <div className="flex-1 overflow-y-auto pe-4">
        <div className="hidden md:block text-xs font-semibold uppercase mb-2">
          Recent Chats
        </div>
        <ul className="space-y-1 flex flex-col items-center md:items-stretch">
          {loadingConversation ? (
            <div className="grid gap-2">
              {[1, 2, 3, 4].map((_, i) => (
                <Skeleton key={i} className="w-full h-14" />
              ))}
            </div>
          ) : (
            filteredUsers.map((user) => (
              <li key={user.id} className="w-full space-y-2">
                <button
                  onClick={() => onSelectUser(user)}
                  className={`flex items-center w-full px-2 py-2 rounded-lg transition-colors ${
                    selectedUser?.id === user.id
                      ? "bg-muted-foreground/20"
                      : "hover:bg-muted-foreground/10"
                  } justify-center md:justify-start`}
                >
                  <Avatar
                    className={cn(
                      "min-w-8 min-h-8 rounded-full flex items-center justify-center text-xs font-medium",
                      "bg-blue-100 text-blue-600",
                      "dark:bg-blue-900 dark:text-blue-300"
                    )}
                    src={`${UrlImage}${user.image}`}
                  >
                    {user.name.charAt(0)}
                  </Avatar>
                  <div className="hidden md:flex ml-3 flex-1 min-w-0 flex-col">
                    <div className="flex justify-between items-center">
                      <p className={cn("text-sm font-medium truncate")}>
                        {user.name}
                      </p>
                      {user.unread > 0 && (
                        <Badge className="ml-2 px-1.5 py-0.5 text-xs hidden md:inline">
                          {user.unread}
                        </Badge>
                      )}
                    </div>
                    <p className="text-xs text-gray-500 truncate">
                      {user.lastMessage}
                    </p>
                  </div>
                </button>
              </li>
            ))
          )}
        </ul>
      </div>

      {/* Footer
      <div className="pe-4 py-3 border-t flex justify-center md:justify-start">
        <button className="flex items-center w-full md:w-auto px-2 py-2 rounded-lg hover:bg-gray-100 justify-center md:justify-start">
          <Settings className="h-5 w-5" />
          <span className="hidden md:inline ml-3 text-sm text-gray-700">
            Settings
          </span>
        </button>
        <button className="flex items-center w-full md:w-auto px-2 py-2 rounded-lg hover:bg-gray-100 justify-center md:justify-start mt-1">
          <LogOut className="h-5 w-5" />
          <span className="hidden md:inline ml-3 text-sm text-gray-700">
            Logout
          </span>
        </button>
      </div> */}
    </aside>
  );
}
